// extracted by mini-css-extract-plugin
module.exports = {"video":"styles_video__3KxUw"};